/*
 * @Author: cn1994
 * @Date: 2023-01-08 14:52:50
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-15 16:04:07
 * @Description: 全局注入封装的组件
 */

import CustomDialog from '@/components/customDialog/index.vue'
import CustomDialogV2 from '@/components/customDialogV2/index.vue'
import CustomDrawer from '@/components/customDrawer/index.vue'
import LsPagination from '@/components/el-pagination.vue'
import EmptyData from '@/components/empty.vue'
import LsToolTip from '@/components/LsToolTip/index.vue'
import TableOpration from '@/components/tableOpration/index.vue'
import CustomDatePicker from '@/components/customDatePicker/index.vue'
import MobilePreview from '@/components/mobilePreview/index.vue'
import CustomSelect from '@/components/customSelect/index.vue'
import WxUserName from '@/components/wx/WxUserName.vue'
import MobilePreviewV2 from '@/components/mobilePreviewV2/index.vue'
import CustomTooltip from '@/components/customTooltip/index.vue'
import CustomLoading from '@/components/customLoading/index.vue'
import CustomBreadcrumb from '@/components/customBreadcrumb/index.vue'
const component = {
  install: function (Vue) {
    Vue.component('CustomDialog', CustomDialog)
    Vue.component('CustomDialogV2', CustomDialogV2)
    Vue.component('CustomDrawer', CustomDrawer)
    Vue.component('LsPagination', LsPagination)
    Vue.component('EmptyData', EmptyData)
    Vue.component('LsToolTip', LsToolTip)
    Vue.component('TableOpration', TableOpration)
    Vue.component('CustomDatePicker', CustomDatePicker)
    Vue.component('MobilePreview', MobilePreview)
    Vue.component('CustomSelect', CustomSelect)
    Vue.component('WxUserName', WxUserName)
    Vue.component('MobilePreviewV2', MobilePreviewV2)
    Vue.component('CustomTooltip', CustomTooltip)
    Vue.component('CustomLoading', CustomLoading)
    Vue.component('CustomBreadcrumb', CustomBreadcrumb)
  }
}

export default component
